export enum PaymentProvider {
 None = '',
 Visa = 'Visa',
 Mastercard = 'Mastercard',
 Skrill = 'Skrill',
 MoneyGram = 'MoneyGram',
 PayPal = 'PayPal',
 Stripe = 'Stripe',
 Alipay = 'Alipay',
 Applepay = 'Applepay',
 Amex = 'Amex',
 Discover = 'Discover',
}
